module.exports = __webpack_public_path__ + "static/media/campus-platform-moduleB-icon26.e03cffe8.png";